module.exports = __webpack_public_path__ + "img/cloud-upload.799119c6.svg";